<template>
  <a-modal
    :closable="false"
    :footer="null"
    v-model="visible"
    destroyOnClose
    @cancel="handleClose"
    width="1080px"
    wrapClassName="conversation"
  >
    <a-row
      type="flex"
      justify="start"
      align="top"
      style="height:603px;"
      v-if="currentConversation.conversationID"
    >
      <a-col span="6" style="height:100%;">
        <user-card></user-card>
      </a-col>
      <a-col span="18" style="height:100%;">
        <current-conversation></current-conversation>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import Api from "@/api";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapMutations } = createNamespacedHelpers("im");
import CurrentConversation from "../c2c/current-conversation";
import BaseModal from "@/components/base-modal.vue";
import UserCard from "./groupProfile/index";
export default {
  name: "conversation",
  extends: BaseModal,
  provide() {
    return {
      closeConversation: this.closeConversation
    };
  },
  components: {
    UserCard,
    CurrentConversation
  },
  computed: {
    ...mapState(["currentConversation"])
  },
  methods: {
    ...mapActions(["checkoutConversation", "updateGroupList"]),
    ...mapMutations(["resetCurrentConversation"]),
    closeConversation() {
      this.close();
      this.handleClose();
    },
    async show(conversationID) {
      this.open();
      await this.checkoutConversation(conversationID);
    },
    handleClose() {
      console.log("关闭群组会话");
      this.updateGroupList();
      this.postcard = false;
      this.resetCurrentConversation();
    }
  }
};
</script>

<style lang="scss">
.conversation {
  .ant-modal-content {
    border-radius: 0;
    position: relative;
    .ant-modal-body {
      padding: 0;
      background: #f5f5f5;
    }
  }
}
</style>
